import { Component, Fragment } from 'react';
import Slider from 'react-slick';
import SliderArrow from '~/js/components/SliderArrow';
import CheckBox from '~/js/components/CheckBox';
import CarouselItem from '~/js/views/general/components/unique-cuisines/CarouselItem';

const internals = {
    sliderOptions: {
        slidesToShow: 3,
        nextArrow: <SliderArrow classNames="arrow arrow-next" />,
        prevArrow: <SliderArrow classNames="arrow arrow-prev" />,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    arrows: false,
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 767,
                settings: {
                    arrows: false,
                    slidesToShow: 1
                }
            }
        ]
    }
};

class FilteredCarousel extends Component {
    state = {
        selectableCuisines: this.props.mealTypes.map(meal => meal.id),
        matchedResorts: Object.keys(this.props.resortsMealTypes),
        checked: {},
        currentSlide: 1
    }

    componentDidUpdate(prevProps, prevState) {
        const { checked } = this.state;

        if (checked !== prevState.checked && !this.isMobile) {
            this.scrollWhenSelect();
        }
    }

    isMobile = window.innerWidth < 768;

    scrollWhenSelect = (offset = 0) => {
        const { checked } = this.state;

        if (Object.keys(checked).length !== 0) {
            const restaurantsCarousel = $('#restaurants-selection');

            $('html, body').animate({
                scrollTop: restaurantsCarousel.offset().top - offset
            }, 1000);
        }
    }

    handleChange = ({ id, name }) => {
        // there must be a request
        this.setState((prevState) => {
            const updatedData = {...prevState.checked};

            if (updatedData.hasOwnProperty(id)) {
                delete updatedData[id];
            } else {
                updatedData[id] = name;
            }

            return {
                checked: updatedData,
                ...this.selectResorts(updatedData)
            };
        });
    }

    selectResorts(selectedCuisines) {
        const resortKeys = Object.keys(this.props.resortsMealTypes);
        const selectedResorts = resortKeys.filter(rstCode => {
            if(Object.keys(selectedCuisines).length === 0) {
                return true;
            }

            return Object.keys(selectedCuisines).every(cuisineId =>
                this.props.resortsMealTypes[rstCode]
                    .find(mealTypeData =>
                        mealTypeData.mealTypeId.toString() === cuisineId
                    ) !== undefined
            );
        });

        return {
            selectableCuisines: this.getSelectableCuisines(selectedResorts),
            matchedResorts: selectedResorts,
        };
    }

    getSelectableCuisines(matchedResorts) {
        const selectableCuisines = matchedResorts.reduce((resultCuisines, rstCode) => {
            resultCuisines.push.apply(resultCuisines, this.props.resortsMealTypes[rstCode]);

            return resultCuisines;
        }, []);

        return [...new Set(selectableCuisines.map(mealType => mealType.mealTypeId))];
    }

    handleApply = () => {
        this.closeFilters();
    }

    handleReset = () => {
        this.setState({
            checked: {},
            ...this.selectResorts({})
        });
    }

    openFilters = () => {
        this.setState({ filterStyle: { display: 'block' } });
    }

    closeFilters = () => {
        this.scrollWhenSelect(10);
        this.setState({ filterStyle: null });
    }

    render() {
        const {
            selectableCuisines,
            matchedResorts,
            checked,
            currentSlide,
            filterStyle
        } = this.state;
        const {
            resortsData,
            cuisines
        } = this.props;
        const { sliderOptions } = internals;
        let filteredData = resortsData;
        let cuisinesList = 'LOADING';
        let carousel = 'No resorts found';

        const carouselHandlers = {
            afterChange: (index) => this.setState({ currentSlide: index + 1 })
        };

        if (cuisines) {
            cuisinesList = (
                <ul className="filter-list">
                    {cuisines.map(currentCuisine => {
                        const { name } = currentCuisine;
                        const isChecked = checked.hasOwnProperty(currentCuisine.id);
                        let isDisabled = false;

                        if (!isChecked && Array.isArray(selectableCuisines)) {
                            isDisabled = !selectableCuisines.includes(currentCuisine.id);
                        }

                        return (
                            <li key={name}>
                                <CheckBox
                                    label={name}
                                    classNames="checkbox"
                                    onChange={() => this.handleChange(currentCuisine)}
                                    isChecked={isChecked}
                                    isDisabled={isDisabled} />
                            </li>
                        );
                    })}
                </ul>
            );
        }

        if (Array.isArray(matchedResorts)) {
            filteredData = resortsData.filter((item) => {
                return matchedResorts.includes(item.code);
            });
        }

        if (filteredData.length) {
            carousel = (
                <Fragment>
                    <Slider ref="slider" {...sliderOptions} {...carouselHandlers}>
                        {filteredData.map((item, index) => {
                            return (
                                <div key={index}>
                                    <CarouselItem {...item} />
                                </div>
                            );
                        })}
                    </Slider>
                    <div className="counter">
                        <SliderArrow
                            classNames="arrow arrow-prev"
                            onClick={() => this.refs.slider.slickPrev()} />
                        {currentSlide}/{filteredData.length}
                        <SliderArrow
                            classNames="arrow arrow-next"
                            onClick={() => this.refs.slider.slickNext()} />
                    </div>
                </Fragment>
            );
        }

        return (
            <div className="filtered-carousel">
                <div className="head">
                    <div className="container">
                        <h2 className="title">Discover Unique Cuisines <span>From Around the world</span></h2>
                        <h3 className="sub-title">Please select which cuisines you&#39;d like to <span>experience during your stay</span></h3>

                        <div id="restaurants-selection">
                            <button
                                className="filters-btn"
                                onClick={this.openFilters}>
                                Select
                            </button>

                            <div className="filters row" style={filterStyle}>
                                <i className="ic ic-close" onClick={this.closeFilters} />

                                <div className="col-md-10 col-md-offset-1">
                                    <div className="filters-head">
                                        <span className="visible-xs">Cuisines</span>
                                        {Object.keys(checked).length !== 0 &&
                                            <button className="reset-btn" onClick={this.handleReset}>
                                                <span>Reset</span><i className="ic ic-reset" />
                                            </button>
                                        }
                                    </div>

                                    {cuisinesList}

                                    <button
                                        className="apply-btn"
                                        onClick={this.handleApply}>
                                        Apply
                                    </button>
                                </div>
                            </div>
                        </div>

                        {Object.keys(checked).length !== 0 &&
                            <h3 className="sub-title match">
                                Your Selections Match: <strong>{filteredData.length} Sandals Resorts</strong>
                            </h3>
                        }
                    </div>
                </div>
                {Object.keys(checked).length !== 0 &&
                    <div className="main">
                        <div className="container">
                            {carousel}
                        </div>

                        {/* <a href="" className="view-all">View All Resorts</a> */}
                    </div>
                }
            </div>
        );
    }
}

export default FilteredCarousel;
